export default __webpack_public_path__ + "static/media/jornal-de-ofertas-logo.8c259b3e.svg";